import apiClient from '../apiClient';

const API_URL = '/art/preexistencias';

// Obtener todas las preexistencias (opcionalmente filtrar por CUIL del cliente)
export const getPreexistencias = async (cuil = null) => {
    const params = {};
    if (cuil && cuil.trim() !== '') params.cuil = cuil;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Obtener preexistencia por ID
export const getPreexistenciaPorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear preexistencia
export const crearPreexistencia = async (data) => {
    const response = await apiClient.post(API_URL, data);
    return response.data;
};

// Actualizar preexistencia
export const actualizarPreexistencia = async (id, data) => {
    const response = await apiClient.put(`${API_URL}/${id}`, data);
    return response.data;
};

// Eliminar preexistencia
export const eliminarPreexistencia = async (id) => {
    const response = await apiClient.delete(`${API_URL}/${id}`);
    return response.data;
};

